export default __webpack_public_path__ + "static/media/case3 (4).4e3d076c.jpg";